import { EspaceNotaire } from './EspaceNotaire.js';

export const ecrans = { X12: EspaceNotaire };
